import React, { useState, useEffect } from 'react';
import newUserStyles from '../styles/newUserStyles';
import BodyContainer from '../ui/BodyContainer';
import SignupSkeleton from '../ui/signupSkeleton';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
// import GroupSharpIcon from '@material-ui/icons/GroupSharp';
import Services from '../services/services';
import Loader from '../ui/Loader';
import toast, { Toaster } from 'react-hot-toast';
import { isAlphabet, isInteger } from '../regexFuncs';
import { getUserBrowserStorage, setUserBrowserStorage } from '../constants';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => newUserStyles(theme));

function MyProfile() {
  const classes = useStyles();
  const history = useHistory();
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const [loader, setLoader] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [errors, setErrors] = useState({});
  const [firstName, setFirstName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [lastName, setLastName] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [email, setEmail] = useState({
    error: false,
    helpertext: null,
    value: '',
  });

  const [phone, setPhone] = useState({
    error: false,
    helpertext: null,
    value: '',
    validLen: 0,
  });

  const [userType, setUserType] = useState('');
  // const icon = <GroupSharpIcon className={classes.icon} />;

  const getUserDetails = async () => {
    try {
      const res = await Services.view_user(userDetails.userId);
      const details = res.data.userDetails[0];
      details.userId = userDetails.userId;

      setUserBrowserStorage('userDetails', JSON.stringify(details));

      setFirstName((prevState) => {
        return {
          ...prevState,
          value: details.firstName ? details.firstName : '',
        };
      });
      setLastName((prevState) => {
        return {
          ...prevState,
          value: details.lastName ? details.lastName : '',
        };
      });
      setEmail((prevState) => {
        return {
          ...prevState,
          value: details.email ? details.email : '',
        };
      });
      setPhone((prevState) => {
        return {
          ...prevState,
          value: details.phone ? details.phone : '',
        };
      });
      setUserType(details.userType);
    } catch (error) {}
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      updateUser();
    }
  };

  const onChangeFirstName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setErrors({});
      setFirstName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };
  const onChangeLastName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setErrors({});
      setLastName({
        error: false,
        helpertext: null,
        value: value,
      });
    }
  };

  const onChangePhone = (value, country) => {
    const validLen = (country.format.match(/\./g) || []).length;
    setErrors({});
    setPhone({
      error: false,
      helpertext: null,
      value: value,
      validLen,
    });
  };

  const Validation_fun = () => {
    const errors = {};

    if (firstName.value === '') {
      errors.firstName = 'First name is required';
    }
    if (lastName.value === '') {
      errors.lastName = 'Last name is required';
    }
    if (phone.value === '') {
      errors.phone = 'Phone number is required';
    } else if (phone.value?.length < phone.validLen) {
      errors.phone = 'Phone number is not valid';
    }

    setErrors(errors);
    const errorStatus = Object.keys(errors).length === 0;
    return errorStatus;
  };

  const updateUser = () => {
    if (Validation_fun()) {
      let user_data = {
        firstName: firstName.value,
        lastName: lastName.value,
        phone: phone.value,
        userType: userType,
      };

      setLoader(!loader);
      Services.update_user(userDetails.userId, user_data)
        .then((userResponce) => {
          if (userResponce.data.responseCode === 200) {
            setLoader(false);
            toast.dismiss();
            toast.success(userResponce.data.details, { duration: 4000 });
            history.push('/myprofile');
          } else {
            setLoader(false);
            toast.dismiss();
            toast.error('failed', { duration: 4000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.dismiss();
          toast.error(error?.response?.data?.phone[0], { duration: 4000 });
        });
    }
  };

  const handleBackButtonHome = () => {
    history.push('/');
  };

  const handleBackButton = () => {
    history.push('/myprofile');
  };

  return (
    <BodyContainer
      title='My Profile'
      icon={
        isDisable
          ? backArrow(handleBackButtonHome)
          : backArrow(handleBackButton)
      }
    >
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <form className={classes.form}>
              <Grid container>
                <SignupSkeleton
                  fromProfPage={true}
                  disabled={isDisable}
                  fError={!!errors?.firstName}
                  fHelp={errors?.firstName}
                  fValue={firstName.value}
                  changeFName={onChangeFirstName}
                  handleEnter={handleEnter}
                  inputStyles={classes.inputStyles}
                  LError={!!errors?.lastName}
                  LHelp={errors?.lastName}
                  LValue={lastName.value}
                  changeLName={onChangeLastName}
                  EError={!!errors?.email}
                  EHelp={errors?.email}
                  EValue={email.value}
                  PError={!!errors?.phone}
                  PHelp={errors?.phone}
                  PValue={phone.value}
                  changePhone={onChangePhone}
                  phoneErrorCls={classes.phoneErrorCls}
                  showPhoneInput={true}
                />
              </Grid>
              <div className={classes.btnDiv}>
                {isDisable ? (
                  <CustomButton
                    btnStyle={classes.button}
                    clickHandle={() => setIsDisable(false)}
                    btnText={'Edit'}
                  />
                ) : (
                  <>
                    <CustomButton
                      btnStyle={classes.button1}
                      clickHandle={() => history.push('/myprofile')}
                      btnText={'Cancel'}
                    />
                    <CustomButton
                      btnStyle={classes.button}
                      clickHandle={updateUser}
                      btnText={'Update'}
                    />
                  </>
                )}
              </div>
            </form>
          </Box>
        </Paper>
      </Grid>
      <Toaster position='top-center'></Toaster>
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default MyProfile;
